var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.contacts),function(contact,index){return _c('div',{key:index,staticClass:"contact"},[_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(contact.firstName))+" "+_vm._s(_vm._f("capitalize")(contact.lastName)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }